import { defineStore } from 'pinia';
import { useAPI } from '~/composables/useAPI';

export const useCandidatosStore = defineStore('candidatos', {
    state: () => ({
        destacados: null,


    }),
    actions: {
        async sendCandidato(payload) {
            const api = useAPI();
            const response = await api.post('candidates', payload);
            //this.destacados = response.data;
        },

    },
});
